export const formatPath = (input) => `${input < 10 ? '0' : ''}${input + 1}.`;
